import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useRetrieveTeam, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { IntraSquadTournamentForm } from "./IntraSquadTournamentForm";
export const CreateIntraSquadTournament = () => {
    const { id: teamId } = useNumericParams();
    const { data: userTeamPermissions, isLoading: userTeamPermissionsIsLoading, error: userTeamPermissionsError, } = useRetrieveUserTeamPermissions({ teamId: teamId });
    const { canModify = false } = userTeamPermissions || {};
    const { isLoading: useRetrieveTeamIsLoading, error: useRetrieveTeamError, data: team, } = useRetrieveTeam({ id: teamId, enabled: canModify });
    const loading = userTeamPermissionsIsLoading || useRetrieveTeamIsLoading;
    if (loading) {
        return _jsx(Loading, {});
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    const dataError = !team || !userTeamPermissions;
    if (dataError) {
        return (_jsx(ErrorView, { error: new Error("Unable to retrieve tournament data!") }));
    }
    const error = useRetrieveTeamError || userTeamPermissionsError;
    if (error) {
        return _jsx(ErrorView, { error: error });
    }
    return (_jsx(React.Fragment, { children: _jsx(IntraSquadTournamentForm, { team: team }) }));
};
